import { render, staticRenderFns } from "./gfinfo.vue?vue&type=template&id=2ce0bf8e&scoped=true"
import script from "./gfinfo.vue?vue&type=script&lang=js"
export * from "./gfinfo.vue?vue&type=script&lang=js"
import style0 from "./gfinfo.vue?vue&type=style&index=0&id=2ce0bf8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce0bf8e",
  null
  
)

export default component.exports